import i18n from '@/config/i18n';
import apiHelper from '@/utils/apiHelper';
import getVisiblePropertiesText from '@/utils/getVisiblePropertiesText';
import customCompsetStatus from '@/config/customCompsetStatus';

const { t } = i18n.global;

const getCustomCompsets = async () => {
  const { data } = await apiHelper(
    'GET',
    '/custom-compset',
    null,
    { useCache: true },
  );

  return data.data.map((item) => {
    const compsetType = item.type || 'property';
    const isBrandCompset = compsetType === 'brand';
    let visibleInText;

    if (isBrandCompset) {
      visibleInText = t('Overview');
    } else {
      visibleInText = getVisiblePropertiesText(item.visibleProperties);
    }

    const {
      text: statusText,
      color: statusColor,
      tooltipText: statusTooltipText = '',
    } = customCompsetStatus[item.status || 'draft'];

    return {
      ...item,
      statusText,
      statusTooltipText,
      statusColor,
      visibleInText,
      type: compsetType,
      isBrandCompset,
    };
  });
};

export default getCustomCompsets;
